// Compact forward-looking injury-risk badge rendered in the DecisionCard.
// Extracted from DecisionEnginePage.js during Phase 1 consolidation —
// no logic or visual changes.
import React from 'react';
import { Brain } from 'lucide-react';

export const PREDICTION_TONE = {
  high: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900',
  moderate: 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900',
  low: 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900',
};

export const PredictionBadge = ({ prediction }) => {
  if (!prediction || typeof prediction.injury_risk_score !== 'number') return null;
  const tone = PREDICTION_TONE[prediction.risk_level] || PREDICTION_TONE.low;
  const levelLabel = (prediction.risk_level || 'low').charAt(0).toUpperCase() + (prediction.risk_level || 'low').slice(1);
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full border text-[11px] font-medium ${tone}`}
      data-testid="prediction-badge"
      data-risk-level={prediction.risk_level}
      data-risk-score={prediction.injury_risk_score}
      aria-label={`Predicted injury risk: ${prediction.injury_risk_score} out of 100, ${levelLabel}`}
    >
      <Brain className="h-3 w-3 shrink-0" />
      <span>Injury Risk: <span data-testid="prediction-score" className="font-semibold">{prediction.injury_risk_score}</span> ({levelLabel})</span>
    </span>
  );
};
